import { Suspense, useLayoutEffect } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import GramaticaVV from '../pages/GramaticaVV'
import Home from '../pages/Home'
import Literatura from '../pages/Literatura'
import { TYPES_LANGUAGES } from '../constants/language'
import { APP_PATHS } from '../constants/routes'

const App = () => {
  const { i18n } = useTranslation()

  useLayoutEffect(() => {
    const languageByUrl = window?.location?.pathname?.split('/')[1]
    if ([TYPES_LANGUAGES.CA, TYPES_LANGUAGES.ES].includes(languageByUrl)) {
      i18n.changeLanguage(languageByUrl)
    }
  }, [])

  return (
    <Suspense fallback={null}>
      <Switch>
        <Route component={GramaticaVV} exact path={APP_PATHS.GRAMMAR} />
        <Route component={Literatura} exact path={APP_PATHS.LITERATURE} />
        <Route component={Home} path={APP_PATHS.BASE} />
        <Redirect from='*' to={APP_PATHS.BASE} />
      </Switch>
    </Suspense>
  )
}

export default App
